// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1lbKj","icon":"SortAdornment_icon__1s43p","up":"SortAdornment_up__33Vmj","down":"SortAdornment_down__2tP2t","active":"SortAdornment_active__46Xnh"};